import React, { useEffect, useState } from 'react'
import { Pagination as MUIPagination } from '@mui/material'
import { Box } from '@mui/system'
import { MthTitle } from '@mth/enums'
import { useStyles } from './styles'
import { PaginationProps } from './types'
import { DropDown } from '../../core/components/shared/DropDown/DropDown'
import { Subtitle } from '../../core/components/shared/Subtitle/Subtitle'

export const Pagination: React.FC<PaginationProps> = ({
  testId,
  setParentLimit,
  handlePageChange,
  defaultValue,
  numPages,
  currentPage,
  dropdownOptions = [
    {
      label: '25',
      value: 25,
    },
    {
      label: '50',
      value: 50,
    },
    {
      label: '100',
      value: 100,
    },
    {
      label: '500',
      value: 500,
    },
  ],
  fontWeight,
}) => {
  const classes = useStyles

  const [limit, setLimit] = useState<number>(0)

  useEffect(() => {
    if (limit && setParentLimit) setParentLimit(limit)
  }, [limit])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <Subtitle size='medium' sx={{ marginRight: '12px', fontWeight: fontWeight || 'initial' }}>
          {MthTitle.SHOW}
        </Subtitle>
        <DropDown
          dropDownItems={dropdownOptions}
          setParentValue={(value) => {
            setLimit(Number(value))
          }}
          alternate={true}
          size='small'
          defaultValue={(defaultValue as string | number | undefined) || dropdownOptions[0].value}
          sx={{ fontWeight: fontWeight || 'initial' }}
        />
      </Box>
      <MUIPagination
        data-testid={testId}
        count={numPages}
        size='small'
        sx={classes.pageNumber}
        onChange={(_e, pageNum) => handlePageChange && handlePageChange(pageNum)}
        page={currentPage}
        disabled={numPages < 2}
      />
    </Box>
  )
}
